export default "__VITE_ASSET__CoJLfzjW__"